import  React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { loadLocalConfig } from './components/utils/LocalConfig';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import "@cpelements/pfe-navigation";
import "@cpelements/rh-account-dropdown";
import "@cpelements/rh-site-switcher";


(async function () {
// Load local config
process.env.REACT_APP_ENV === "local" && (await loadLocalConfig());

ReactDOM.render(
  <BrowserRouter basename="/search">
    <React.StrictMode>
      <Switch>
        <Route exact path="/" render={(routeProps) => <App routeProps={routeProps} />}/>
      </Switch>
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')
)})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
